import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { HighChartsSetupService } from '@services/charts/high-charts-setup.service';
import {LANGUAGES} from '@services/translation/languages-definitions';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  activeLanguageKey: string;
  activeLanguageFlag: string;

  private portalLanguageChangeSubject = new Subject<string>();

  constructor(public translate: TranslateService,
              private highChartSetup: HighChartsSetupService) {

    translate.addLangs(this.getLanguagesKeys());

    this.activeLanguageKey = LANGUAGES[0].key;
    this.activeLanguageFlag = LANGUAGES[0].flag;
  }

  public getLanguageChangeEventSubject(){
    return this.portalLanguageChangeSubject;
  }

  public useLanguage(language: string): void {

    const foundLanguage = LANGUAGES.find(lang => lang.key.toLowerCase() === language.toLowerCase());
    if (foundLanguage) {
      this.activeLanguageKey = foundLanguage.key;
      this.activeLanguageFlag = foundLanguage.flag;
      this.translate.use(foundLanguage.key);
    } else {
      this.activeLanguageKey = LANGUAGES[0].key;
      this.activeLanguageFlag = LANGUAGES[0].flag;
      this.translate.use(LANGUAGES[0].key);
    }
    this.portalLanguageChangeSubject.next(this.activeLanguageKey);
    this.highChartSetup.setupHighchartLocalization(this.getActiveLanguage());
  }

  public getActiveLanguage(): string {
    return this.activeLanguageKey;
  }

  public getActiveLanguageFlag(): string {
    return this.activeLanguageFlag;
  }

  private getLanguagesKeys(): string[] {
    const keys: (string)[] = [];
    for (const language of LANGUAGES) {
      keys.push(language.key);
    }
    return keys;
  }

}
